import { render, staticRenderFns } from "./ReportRestriction.vue?vue&type=template&id=018fc707&"
import script from "./ReportRestriction.vue?vue&type=script&lang=js&"
export * from "./ReportRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports